import axios from "axios";
import { urlBase } from "../config";

const plainAxios = axios.create({ baseURL: urlBase });

export const refreshApi = async (refreshToken) => {
  try {
    const response = await plainAxios.post("/api/auth/refresh", { refreshToken });
    return {
      isSuccess: true,
      newAuthToken: response.data.accessToken,
      newRefreshToken: response.data.refreshToken,
    };
  } catch (err) {
    if (err.response?.status === 429) {
      console.warn("Refresh rate limited (429).");
      return { isSuccess: false, isRateLimited: true };
    }
    console.error("Refresh failed:", err);
    return { isSuccess: false, isRateLimited: false };
  }
};

export const logoutApi = async (accessToken, refreshToken) => {
  try {
    await plainAxios.post(
      "/api/auth/logout",
      { refreshToken },
      { headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {} }
    );
  } catch (err) {
    // ignoruj błędy przy wylogowaniu – i tak czyścimy storage
  }
};
